export interface LabelManagementConfig {
  /** The text that appears in the default header of the modal component next to the close icon. */
  header: string;
  /** The text appearing at the top of the modal body. */
  title: string;
  /** The explanatory text appearing below the label and above the divider between the top of the body and the dropdown. */
  displayText: string;
  /** The label label above the typeahead dropdown. */
  displayLabel: string;
  /** The text inside the button to cancel the selection. */
  cancelButtonLabel: string;
  /** The text inside the button to save the selection. */
  addButtonLabel: string;
  /** The suggestion text below the typeahead dropdown. */
  labelHelpText: string;
  /** The title of the sub-modal that appears when you try to cancel with some selections. */
  warningModalTitle: string;
  /** The explanatory text within the sub-modal. */
  warningModalDescription: string;
  /** The text inside the return button of the sub-modal. */
  warningModalReturnButtonText: string;
  /** The text inside the discard button of the sub-modal. */
  warningModalDiscardButtonText: string;
  maxNumberOfLabelsAllowed: number;
  maxNumberOfLabelsAllowedWarning: string;
  maxLabelLength: number;
  maxLabelLengthWarning: string;
  newLabel: string;
}
